import { i18n } from '@/main'
import { toLowerCamelCase } from '@/utils/string'

export default {
  methods: {
    getPositionWithSchoolName(position, schoolName) {
      if (position && position.positionId && schoolName) {
        return `(${i18n.t(`profile.position.${toLowerCamelCase(position.position)}`)} - ${schoolName})`
      } else if (schoolName) {
        return `(${schoolName})`
      } else if (position && position.positionId) {
        return `(${i18n.t(`profile.position.${toLowerCamelCase(position.position)}`)})`
      } else return ''
    }
  }
}
